<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-05"></menubar>
    </div>

    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">{{$t('title.system.building.title')}}</label>
        <sp-smart-button @click="back" slot="cancel">キャンセル</sp-smart-button>
        <narrowDown @click="functionSave" slot="create">{{ $t("button.common.data.create") }}</narrowDown>
      </headTitle>
    </el-row>

    <div slot="body">

      <!-- subtitle -->
      <div class="main-title">
        {{ $t("title.system.function.setUp") }}
      </div>

      <glanceAll
        v-if="isShowReset"
        @click="clear"
        class="reset-button-with m-left-612">
        {{ $t("button.common.data.resetInitialState") }}
      </glanceAll>

      <div class="func-setup">
        <el-form :model="form">
          <el-form-item>
            <el-col :span="12">
              <!-- 画面左 -->
              <div
                v-for="codeOne in form.functionCodeLeft"
                class="m-top-5 width-400"
                :key="codeOne.code">
                <el-row>
                  <!-- アレイの最初のレイヤーをループします -->
                  <div
                    class="form-group"
                    :class="{'m-bottom-11': codeOne.selectableFlag == false}">
                    <div class="codeOne-font lable-font-color width-320">
                      {{$t("label.system.functionSetUp." + codeOne.code)}}
                    </div>
                    <div>
                      <el-switch
                        v-model="codeOne.flag"
                        :disabled="codeOne.modifiableFlag == false"
                        @change="editfunctionCodeLeftOne(codeOne.code,codeOne.flag)"
                        v-if="codeOne.selectableFlag">
                      </el-switch>
                    </div>
                  </div>
                  <el-row>
                    <!-- 2番目の配列をループします -->
                    <div
                      v-for="codeTwo in codeOne.subFunctionList"
                      :key="codeTwo.code">
                      <el-row class="margin-top-14">

                        <div class="form-group">
                          <div
                            class="ft-16 lable-font-color width-320"
                            :class="{'line-height-16': codeTwo.selectableFlag == false}">
                            {{$t("label.system.functionSetUp." + codeTwo.code)}}
                          </div>
                          <div>
                            <el-switch
                              v-model="codeTwo.flag"
                              :disabled="codeTwo.modifiableFlag == false"
                              @change="editfunctionCodeLeftTwo(codeTwo.code,codeTwo.flag)"
                              v-if="codeTwo.selectableFlag">
                            </el-switch>
                          </div>
                        </div>

                        <!-- 第3レベルの配列をループします -->
                        <div
                          v-for="codeThree in codeTwo.subFunctionList"
                          :key="codeThree.code">
                          <el-row class="three-move margin-top-14">

                            <div class="form-group">
                              <div
                                class="ft-16 lable-font-color width-270"
                                :class="{'line-height-16': codeThree.selectableFlag == false}">
                                {{$t("label.system.functionSetUp." + codeThree.code)}}
                              </div>
                              <div>
                                <el-switch
                                  v-model="codeThree.flag"
                                  :disabled="codeThree.modifiableFlag == false"
                                  @change="editfunctionCodeLeftThree(codeThree.code,codeThree.flag)"
                                  v-if="codeThree.selectableFlag">
                                </el-switch>
                              </div>
                            </div>

                            <!-- 第4レベルの配列をループします -->
                            <div
                              v-for="codeFour in codeThree.subFunctionList"
                              :key="codeFour.code">
                              <el-row class="four-move margin-top-14">

                                <div class="form-group">
                                  <div
                                    class="ft-16 lable-font-color width-220"
                                    :class="{'line-height-16': codeFour.selectableFlag == false}">
                                    {{$t("label.system.functionSetUp." + codeFour.code)}}
                                  </div>
                                  <div>
                                    <el-switch
                                      v-model="codeFour.flag"
                                      :disabled="codeFour.modifiableFlag == false"
                                      @change="editfunctionCodeLeftfour(codeFour.code,codeFour.flag)"
                                      v-if="codeFour.selectableFlag">
                                    </el-switch>
                                  </div>
                                </div>

                              </el-row>
                            </div>
                          </el-row>
                        </div>
                      </el-row>
                    </div>
                  </el-row>
                </el-row>
                <hr class="hr margin-top-40">
              </div>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import headTitle from "@/components/common/head/head";
import glanceAll from "@/components/common/generalButton/GlanceAll";
import SpSmartButton from "@/components/common/sp-smart-button";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import Menubar from "@/components/leftmenu/DashBoard";

export default {
  name: "system-FunctionSetUp",
  components: {
    MainLayout: NewDesignLayout,
    narrowDown: narrowDown,
    headTitle: headTitle,
    LoadingDialog: LoadingDialog,
    glanceAll: glanceAll,
    SpSmartButton: SpSmartButton,
    elDialogPrompt: elDialogPrompt,
    Menubar: Menubar
  },
  data() {
    return {
      outlookFlg: false,
      msgParam: this.$t("message.common.settingConfirm", {
        field: this.$t("label.system.functionSetUp.messageFunction"),
      }),
      isShowReset: false,
      showLoading: false,
      centerDialogVisibleIsShow:false,
      formMsg: {
        paramBuildingId: null,
        paramId: null,
      },
      buildingId: null,
      buildingName: null,
      buildingExId: null,
      form: {
        functionCodeRight: [],
        functionCodeLeft: [],
      },
      functionCode: [],
      functionCodeListfour: [
        {
          code: null,
          selectableFlag: Boolean,
          modifiableFlag: Boolean,
          flag: Boolean,
        },
      ],
      functionCodeListThree: [
        {
          code: null,
          selectableFlag: Boolean,
          modifiableFlag: Boolean,
          flag: Boolean,
          subFunctionList: [],
        },
      ],
      functionCodeListTwo: [
        {
          code: null,
          selectableFlag: Boolean,
          modifiableFlag: Boolean,
          flag: Boolean,
          subFunctionList: [],
        },
      ],
      functionCodeList: [],
      backFlag:false,
      entrancDeviceFunc:null,
    };
  },
  methods: {
    //checkboxメッセージ検索
    searchfunction() {
      SystemManageApi.functionSettingPageInit(this.formMsg.paramBuildingId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          this.form.functionCodeRight = [];
          this.form.functionCodeLeft = [];
          this.functionCode = data.body.functionList;
          for (let codeOne of data.body.functionMasterList) {
            this.functionCodeListfour = [];
            this.functionCodeListThree = [];
            this.functionCodeListTwo = [];
            if (codeOne.subFunctionList.length > 0) {
              for (let codetwo of codeOne.subFunctionList) {
                this.functionCodeListfour = [];
                this.functionCodeListThree = [];
                if (codetwo.subFunctionList.length > 0) {
                  for (let codeThree of codetwo.subFunctionList) {
                    this.functionCodeListfour = [];
                    if (codeThree.subFunctionList.length > 0) {
                      for (let codeFour of codeThree.subFunctionList) {
                        if (this.functionCode.indexOf(codeFour.code) >= 0) {
                          this.functionCodeListfour.push({
                            code: codeFour.code,
                            selectableFlag: codeFour.selectableFlag,
                            modifiableFlag: codeFour.modifiableFlag,
                            flag: true,
                          });
                        } else {
                          this.functionCodeListfour.push({
                            code: codeFour.code,
                            selectableFlag: codeFour.selectableFlag,
                            modifiableFlag: codeFour.modifiableFlag,
                            flag: false,
                          });
                        }
                      }
                    }
                    if (this.functionCode.indexOf(codeThree.code) >= 0) {
                      this.functionCodeListThree.push({
                        code: codeThree.code,
                        selectableFlag: codeThree.selectableFlag,
                        modifiableFlag: codeThree.modifiableFlag,
                        flag: true,
                        subFunctionList: this.functionCodeListfour,
                      });
                    } else {
                      this.functionCodeListThree.push({
                        code: codeThree.code,
                        selectableFlag: codeThree.selectableFlag,
                        modifiableFlag: codeThree.modifiableFlag,
                        flag: false,
                        subFunctionList: this.functionCodeListfour,
                      });
                    }
                  }
                }
                if (this.functionCode.indexOf(codetwo.code) >= 0) {
                  this.functionCodeListTwo.push({
                    code: codetwo.code,
                    selectableFlag: codetwo.selectableFlag,
                    modifiableFlag: codetwo.modifiableFlag,
                    flag: true,
                    subFunctionList: this.functionCodeListThree,
                  });
                } else {
                  this.functionCodeListTwo.push({
                    code: codetwo.code,
                    selectableFlag: codetwo.selectableFlag,
                    modifiableFlag: codetwo.modifiableFlag,
                    flag: false,
                    subFunctionList: this.functionCodeListThree,
                  });
                }
              }
            }
            if (this.functionCode.indexOf(codeOne.code) >= 0) {
              this.form.functionCodeLeft.push({
                code: codeOne.code,
                selectableFlag: codeOne.selectableFlag,
                modifiableFlag: codeOne.modifiableFlag,
                flag: true,
                subFunctionList: this.functionCodeListTwo,
              });
            } else {
              this.form.functionCodeLeft.push({
                code: codeOne.code,
                selectableFlag: codeOne.selectableFlag,
                modifiableFlag: codeOne.modifiableFlag,
                flag: false,
                subFunctionList: this.functionCodeListTwo,
              });
            }
          }

          this.handleModifiableFlag();
          this.getfunctionCode();
          this.getEntranceDeviceFunc();
          this.isShowReset = true
        })
        .finally(() => {});
    },
    handleModifiableFlag() {
      if (!Array.isArray(this.form.functionCodeListTwo)) return
      if (!Array.isArray(this.form.functionCodeListThree)) return

      this.form.functionCodeListTwo.forEach(item => {
        if (
          this.outlookflg === true &&
          typeof item.code === 'string' &&
          item.code.startsWith('02')
        ) {
          item.modifiableFlag = false
        }

        if (
          this.outlookflg === false &&
          typeof item.code === 'string' &&
          item.code.startsWith('13')
        ) {
          item.modifiableFlag = false
        }
      })
      this.form.functionCodeListThree.forEach(item => {
        if (
          this.outlookflg === true &&
          typeof item.code === 'string' &&
          item.code.startsWith('02')
        ) {
          item.modifiableFlag = false
        }

        if (
          this.outlookflg === false &&
          typeof item.code === 'string' &&
          item.code.startsWith('13')
        ) {
          item.modifiableFlag = false
        }
      })
    },
    functionSave() {
      this.centerDialogVisibleIsShow = true
    },
    isPassParam(param){
      if(param){
        this.doneFunctionSave();
      }
    },
    doneFunctionSave() {
      this.centerDialogVisibleIsShow = false
      this.showLoading = true
      this.getfunctionCode();

      var officeFlg = this.functionCodeList.find(item => item == "070100")
      var personPointFlg = this.functionCodeList.find(item => item == "080200")
      if (officeFlg != undefined && officeFlg != null && personPointFlg != undefined && personPointFlg != null) {
        this.showLoading = false
        this.$messageIotError(this.$t("message.common.validation.functionSettingErrMessage"));
        return
      }

      var officePointFlg = this.functionCodeList.find(item => item == "080100")
      if (personPointFlg != undefined && personPointFlg != null) {
        if (officePointFlg == undefined || officePointFlg == null) {
          this.showLoading = false
          this.$messageIotError(this.$t("message.common.validation.functionSettingErrPointMessage"));
          return
        }
      }

      let ipdipadBuildosNecQRList = ["060211","060252","060253"];
      let fundList = [];
      for(let code of this.functionCodeList){
        if(ipdipadBuildosNecQRList.includes(code)){
          fundList.push(code)
        }
      }
      if(fundList.length > 1){
        let msgCode = ''
        if( !this.$IsNullOrEmpty(this.entrancDeviceFunc) && fundList.includes(this.entrancDeviceFunc)){
          msgCode = 'label.system.functionSetUp.' + this.entrancDeviceFunc;
          this.showLoading = false;
          this.$messageIotError(this.$t("message.common.error.ERR_IPAD_BUILDOS_NECQR_MSG", {funcationName: this.$t(msgCode)}));
          return
        }else{
          this.showLoading = false;
          this.$messageIotError(this.$t("message.common.error.ERR_IPAD_BUILDOS_NECQR_VALIDATE_MSG"));
          return
        }

      }

      SystemManageApi.functionSetting({
        buildingId: this.formMsg.paramBuildingId,
        functions: this.functionCodeList,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then((data) => {
        if(data.data.statusCode == 'Failure.NotTenoughGuid'){
          this.backFlag = false;
          this.$messageIotError(this.$t('message.common.error.ERR_NOT_ENOUGH_GUID_MSG'));
          this.$nextTick(function(){
            this.searchfunction();
          })
          return;
        }
        if(data.data.statusCode == 'Failure.ErrOutlookRestrictedByWoFacilityMsg'){
          this.backFlag = false;
          this.$messageIotError(this.$t('message.common.error.ERR_OUTLOOK_RESTRICTED_BY_WO_FACILITY_MSG'));
          this.$nextTick(function(){
            this.searchfunction();
          })
          return;
        }
        if(data.data.statusCode == 'Failure.ErrWoFacilityRestrictedByOutlookMsg'){
          this.backFlag = false;
          this.$messageIotError(this.$t('message.common.error.ERR_WO_FACILITY_RESTRICTED_BY_OUTLOOK_MSG'));
          this.$nextTick(function(){
            this.searchfunction();
          })
          return;
        }
        this.$nextTick(function(){
          this.backFlag = true;
          if(this.backFlag){
            this.back();
          }
        })
        this.saveSuccess();
      }).finally(()=>{
        this.showLoading = false
      });
    },
    clear() {
      location.reload();
    },
    back() {
      if (this.formMsg.paramId === "1") {
        this.$router.push({
          name: "system-building-search",
        });
      } else {
        this.$router.push({
          name: "system-building-manage-menu",
          params: {
            buildingId: this.formMsg.paramBuildingId,
          },
        });
      }
    },
    saveSuccess() {
      this.backFlag = true;
      this.$messageIotSuccess(this.$t("message.common.functionSetting"));
    },
    //機能IDリスト
    getfunctionCode() {
      this.functionCodeList = [];
      for (let codeOne of this.form.functionCodeLeft) {
        if (codeOne.flag == true) {
          this.functionCodeList.push(codeOne.code);
        }
        if (codeOne.subFunctionList.length > 0) {
          for (let codeTwo of codeOne.subFunctionList) {
            if (codeTwo.flag == true) {
              this.functionCodeList.push(codeTwo.code);
            }
            if (codeTwo.subFunctionList.length > 0) {
              for (let codeThree of codeTwo.subFunctionList) {
                if (codeThree.flag == true) {
                  this.functionCodeList.push(codeThree.code);
                }
                if (codeThree.subFunctionList.length > 0) {
                  for (let codeFour of codeThree.subFunctionList) {
                    if (codeFour.flag == true) {
                      this.functionCodeList.push(codeFour.code);
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    editfunctionCodeLeftOne(value,flag){
      this.syncLinkedSwitch(value, flag)
      if(flag == false){
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            if(this.form.functionCodeLeft[i].code == value){
              for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
                if(this.form.functionCodeLeft[i].subFunctionList[j].modifiableFlag == true){
                  this.form.functionCodeLeft[i].subFunctionList[j].flag = false
                }
                if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length > 0) {
                  for (let n =0; n < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length;n++) {
                    if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].modifiableFlag == true){
                      this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].flag = false
                    }
                    if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length > 0) {
                      for(let m =0; m < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length;m++){
                        if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].modifiableFlag == true){
                          this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].flag = false
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

    },
    editfunctionCodeLeftTwo(value,flag) {
      this.syncLinkedSwitch(value, flag)
      if(flag==true){
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
              if (this.form.functionCodeLeft[i].subFunctionList[j].code == value) {
                if(this.form.functionCodeLeft[i].modifiableFlag == true){
                  this.form.functionCodeLeft[i].flag = true
                }
              }
            }
          }
        }
        this.handleGroupExclusiveByCode(value)
      }else{
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
              if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length > 0 && this.form.functionCodeLeft[i].subFunctionList[j].code==value) {
                for (let n =0; n < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length;n++) {
                  if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].modifiableFlag == true){
                    this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].flag = false
                  }
                  if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length > 0) {
                    for(let m =0; m < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length;m++){
                      if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].modifiableFlag == true){
                        this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].flag = false
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

    },
    editfunctionCodeLeftThree(value,flag) {
      this.syncLinkedSwitch(value, flag)
      if(flag==true){
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
              if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length > 0) {
                for (let n =0; n < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length;n++) {
                  if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].code == value ){
                    if(this.form.functionCodeLeft[i].subFunctionList[j].modifiableFlag == true){
                      this.form.functionCodeLeft[i].subFunctionList[j].flag = true
                    }
                    if(this.form.functionCodeLeft[i].modifiableFlag == true){
                      this.form.functionCodeLeft[i].flag = true
                    }
                  }
                }
              }
            }
          }
        }
        this.handleGroupExclusiveByCode(value)
      }else{
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
              if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length > 0 ) {
                for (let n =0; n < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length;n++) {
                  if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length > 0 && this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].code==value) {
                    for(let m =0; m < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length;m++){
                      if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].modifiableFlag == true){
                        this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].flag = false
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    editfunctionCodeLeftfour(value,flag) {
      this.syncLinkedSwitch(value, flag)
      if(flag==true){
        for (let i =0; i < this.form.functionCodeLeft.length;i++) {
          if (this.form.functionCodeLeft[i].subFunctionList.length > 0) {
            for (let j =0; j < this.form.functionCodeLeft[i].subFunctionList.length;j++) {
              if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length > 0) {
                for (let n =0; n < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList.length;n++) {
                  if (this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length > 0) {
                    for (let m =0; m < this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList.length;m++) {
                      if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].subFunctionList[m].code == value ){
                        if(this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].modifiableFlag == true){
                          this.form.functionCodeLeft[i].subFunctionList[j].subFunctionList[n].flag = true
                        }
                        if(this.form.functionCodeLeft[i].subFunctionList[j].modifiableFlag == true){
                          this.form.functionCodeLeft[i].subFunctionList[j].flag = true
                        }
                        if(this.form.functionCodeLeft[i].modifiableFlag == true){
                          this.form.functionCodeLeft[i].flag = true
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    handleGroupExclusiveByCode(code) {
      const groupWo = ['130100', '130200', '130300', '130400'];
      const groupOt = ['020100', '020400', '020200', '020600', '020300', '020500', '020700'];

      let needCloseGroup = null;

      if (groupWo.includes(code)) {
        needCloseGroup = groupOt;
      } else if (groupOt.includes(code)) {
        needCloseGroup = groupWo;
      } else {
        return;
      }

      const closeGroup = (list, groupCodes) => {
        list.forEach(item => {
          if (groupCodes.includes(item.code) && item.modifiableFlag === true) {
            item.flag = false;
          }
          if (item.subFunctionList && item.subFunctionList.length > 0) {
            closeGroup(item.subFunctionList, groupCodes);
          }
        });
      };

      closeGroup(this.form.functionCodeLeft, needCloseGroup);
    },
    closeSubFunctionFlags(list) {
      if (!Array.isArray(list) || list.length === 0) return
      list.forEach(item => {
        if (item.modifiableFlag === true) {
          item.flag = false
        }
        if (item.subFunctionList && item.subFunctionList.length > 0) {
          this.closeSubFunctionFlags(item.subFunctionList)
        }
      })
    },
    syncLinkedSwitch(code, flag) {
      const linkMap = {
        '130100': '130400',
        '130400': '130100',
      }
      const isDirectLinked = !!linkMap[code]
      if (!isDirectLinked && flag === false) {
        return
      }
      const resolvedCode = isDirectLinked ? code : this.findLinkedAncestorCode(code, linkMap)
      const targetCode = linkMap[resolvedCode]
      if (!targetCode) return

      const syncFlag = (list) => {
        list.forEach(item => {
          if (item.code === targetCode && item.modifiableFlag === true) {
            if (item.flag !== flag) {
              item.flag = flag
            }
            if (flag === false) {
              this.closeSubFunctionFlags(item.subFunctionList)
            }
          }
          if (item.subFunctionList && item.subFunctionList.length > 0) {
            syncFlag(item.subFunctionList)
          }
        })
      }

      syncFlag(this.form.functionCodeLeft)
    },
    findLinkedAncestorCode(code, linkMap) {
      let result = null
      const linkKeys = Object.keys(linkMap)

      const dfs = (list, ancestorLinkCode) => {
        if (!Array.isArray(list) || result) return
        for (const item of list) {
          const nextAncestor = linkKeys.includes(item.code) ? item.code : ancestorLinkCode
          if (item.code === code) {
            result = nextAncestor
            return
          }
          if (item.subFunctionList && item.subFunctionList.length > 0) {
            dfs(item.subFunctionList, nextAncestor)
            if (result) return
          }
        }
      }

      dfs(this.form.functionCodeLeft, null)
      return result
    },


    initBread() {
      let breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/buildings/search",
          title: "label.router.building",
        },
        {
          path: "",
          title: "label.router.buildingDeatil",
        },
        {
          path: "",
          title: "label.router.Functionalset",
        }
      ];
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    },
    getEntranceDeviceFunc(){
      let entrancDeviceFuncList = ["060211","060252","060253"];
      let fundList = [];
      for(let code of this.functionCodeList){
        if(entrancDeviceFuncList.includes(code)){
          fundList.push(code);
        }
      }
      if (fundList.length > 0) {
        this.entrancDeviceFunc = fundList[0];
      }
    }
  },
  created() {
    this.$authCheck("010306")
    this.initBread()
    this.formMsg.paramBuildingId = this.$route.params.buildingId;
    this.formMsg.paramId = this.$route.params.id;
  },
  mounted() {
    this.searchfunction();
  },
};
</script>

<style lang="scss" scoped>
.two-move {
  margin-left: 2em;
}
.codeOne-font{
  line-height: 20px !important;
  font-size: 20px;
}
.margin-top-40{
  margin-top: 40px;
}
.three-move {
  margin-left: 52px;
}
.four-move {
  margin-left: 52px;
}
::v-deep .label-move-two div:first-child label {
  margin-left: 1em;
}
::v-deep .label-move-three div:first-child label {
  margin-left: 2em;
}
.line-height-36 {
  line-height: 36px;
}
.el-switch {
  height: 32px !important;
}

.func-setup::v-deep {
  .el-switch__core {
    width: 64px !important;
  }
}

.el-switch__core:after {
  margin-top: 1.5px;
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMSAzMSI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuMjEyIiB5MT0iMC4wOTQiIHgyPSIwLjc2OCIgeTI9IjAuODI0IiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2YyZjJlZCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNkMWQxY2QiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8ZmlsdGVyIGlkPSJrbm9iIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxmZU9mZnNldCBkeD0iMSIgZHk9IjEiIGlucHV0PSJTb3VyY2VBbHBoYSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIwLjUiIHJlc3VsdD0iYmx1ciIvPgogICAgICA8ZmVGbG9vZCBmbG9vZC1jb2xvcj0iIzNlNzg3ZCIvPgogICAgICA8ZmVDb21wb3NpdGUgb3BlcmF0b3I9ImluIiBpbjI9ImJsdXIiLz4KICAgICAgPGZlQ29tcG9zaXRlIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICA8L2ZpbHRlcj4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTIiIHgxPSIwLjIxMiIgeTE9IjAuMDk0IiB4Mj0iMC43MjEiIHkyPSIwLjgxNyIgeGxpbms6aHJlZj0iI2xpbmVhci1ncmFkaWVudCIvPgogIDwvZGVmcz4KICA8ZyBpZD0iYnRuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCAtMC41LCAtMC41KSIgZmlsdGVyPSJ1cmwoI2tub2IpIj4KICAgICAgPGNpcmNsZSBpZD0ia25vYi0yIiBkYXRhLW5hbWU9Imtub2IiIGN4PSIxNCIgY3k9IjE0IiByPSIxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IDAuNSkiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPgogICAgPC9nPgogICAgPGNpcmNsZSBpZD0ia25vYi0zIiBkYXRhLW5hbWU9Imtub2IiIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQgMjQpIHJvdGF0ZSgxODApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudC0yKSIvPgogIDwvZz4KPC9zdmc+Cg==) no-repeat !important;
  width: 28px !important;
  height: 28px !important;
  margin-left: 0px !important;
  top: 0px !important;
}

.el-switch.is-checked .el-switch__core {
  background-color: #329CA6 !important;
  border: 0 !important;
}

.el-switch.is-checked .el-switch__core:after {
  right: 5px !important;
  margin-left: -30px !important;
}
.padding-right-36{
  padding-right: 36px;
}
::v-deep .line-height-36{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.hr {
  height: 1px;
  width: 800px;
  background-color: #D1D1CD;
}
/* No.133 begin*/
.margin-top-14 {
  margin-top: 14px;
}

.margin-bottom-11 {
  margin-bottom: 11px;
}
.lable-font-color {
  color: #525250;
}
::v-deep .el-col-20{
  width: 1136px;
}

::v-deep .reset-button-with {
  .my-button {
    width: 188px !important;
  }
}
.m-top-60 {
  margin-top: 60px;
}
.m-bottom-20 {
  margin-bottom: 20px;
}
.m-left-612 {
  margin-left: 612px;
}
/* No.133 end*/

.ft-16 {
  font-size: 16px;
}

.func-setup::v-deep {
  .el-form-item__content {
    line-height: 0px !important;
  }
}

.line-height-16 {
  line-height: 16px;
}

.margin-top-25 {
  margin-top: 25px;
}
.m-bottom-11 {
  margin-bottom: 11px;
}
.width-400 {
  width: 400px;
}
.width-320 {
  width: 320px;
}
.width-270 {
  width: 270px;
}
.width-220 {
  width: 220px;
}
</style>
